var React = require('react');
var ReactNative = require('react-native');



var Animated = require('./wrappers/Animated')

import Icon from './wrappers/ReUpIcon';
var Ionicon = Icon;
// import Ionicon from 'react-native-vector-icons/Ionicons';
var Globals = require('./Globals');

var MK = require('./wrappers/react-native-material-kit-wrapper');
var {
  MKButton,
} = MK;

var {
  AppRegistry,
  Text,
  StyleSheet,
  View,
  StyleSheet,
} = ReactNative;

var ReUpIconButton = require("create-react-class")(
{
  getDefaultProps : function()
  {
    return {
      appManager: {},
      iconName: "",
      ionicIconName: null,
      type : 0, // 0 primary, 1 secondary, 2 nav bar button
      onPress : null,
      iconSize : 22,
      appActions : null,
      featureData : null,
      locParams : [],
      accessibilityLabel : "Button",
      enabled : true,
      alertMessage : null,
      buttonColorOverride : null,
    }
  },

  getInitialState : function()
  {
    return {
      type : this.props.type,
      iconName : this.props.iconName,
      onPress : this.props.onPress,
      isSecondary : this.props.isSecondary,
      opacity : 1,
    }
  },

  setStateExternal : function(newState)
  {
    this.setState(newState);
  },

  setOpacity : function(opacity)
  {
    opacity = Math.max(0, Math.min(1,opacity));
    if( opacity != this.state.opacity )
    {
      this.state.opacity = opacity;
      this.setState({opacity});
    }
  },

  render: function()
  {
    var {iconName, ionicIconName, isSecondary, onPress, type, accessibilityLabel, enabled, ...other} = this.state;
    if( typeof enabled === 'undefined' ) enabled = true;
    var iconSize = this.props.iconSize;
    var lineHeight = iconSize;
    if( (iconName == null || iconName.length <= 0) && type != 3 && (ionicIconName == null || ionicIconName.length <= 0) ) return <View />;

    var appManager = this.props.appManager;
    var style = this.props.style;
    if( typeof style === 'undefined' ) style = {};
    style = [style, styles.buttonStyle];
    var buttonColor = "transparent";
    var buttonTitleColor = "transparent";
    var buttonBorderColor = "transparent";
    var rippleColor = null;

    var ionIconSize = 28;

    var addedIconStyle = {backgroundColor:'transparent'};

    var AccentColoredFab = MKButton.accentColoredFab()
      .withStyle(styles.creditCardEditButton)
      .build();

    if( type == 0 ) // primary
    {
      buttonColor = appManager.getColorForKey("ButtonPrimaryColor");
      buttonTitleColor = appManager.getColorForKey("ButtonPrimaryTitleColor");
      buttonBorderColor = appManager.getColorForKey("ButtonPrimaryBorderColor");
      style.push({elevation:2});
    }
    else if( type == 1 ) // secondary
    {
      buttonColor = appManager.getColorForKey("ButtonSecondaryColor");
      buttonTitleColor = appManager.getColorForKey("ButtonSecondaryTitleColor");
      buttonBorderColor = appManager.getColorForKey("ButtonSecondaryBorderColor");
      style.push({elevation:2});
    }
    else if( type == 2 ) // header icon
    {
      buttonColor = appManager.getColorForKey("HeaderColor");
      buttonTitleColor = appManager.getColorForKey("HeaderIconColor");
      rippleColor = appManager.getColorForKey("HeaderIconColor", 0.2);
      iconSize = 18;
      style.push({height:36, width:36, margin:4})
    }
    else if( type == 3 ) // tutorial icon
    {
      if( this.props.featureData == null ||
          this.props.appActions == null ) return <View />

      buttonColor = 'transparent';//appManager.getColorForKey("ButtonSecondaryColor");
      buttonTitleColor = appManager.getColorForKey("InstructionTitleColor");
      buttonBorderColor = 'transparent';//appManager.getColorForKey("ButtonSecondaryBorderColor");
      iconName = "question-circle";
      var tutorialFeature = appManager.getFeatureForName("Tutorial");
      if( typeof tutorialFeature !== 'undefined' ) iconName = tutorialFeature.data.icon.replace("fa-", "");
      iconSize = 18;
      var appActions = this.props.appActions;
      var locManager = appManager.getLocalizationManager();
      var gotItButton = locManager.localizedStringForKey("GOT_IT_ALERT_BUTTON");//TODO:localize
      var featureData = this.props.featureData;
      style.push({width:28,height:28, margin:4, marginRight:12})
      style.push(Globals.TUTORIAL_ICON_STYLE)
      var instructions = this.props.alertMessage == null ? locManager.localizedStringForKeyAndParams(featureData.instructions, this.props.locParams) : this.props.alertMessage;
      if( typeof onPress === 'undefined' || onPress == null )
      {
        onPress = function()
        {
          appActions.showAlert(featureData.title,instructions,[gotItButton],[appActions.hideAlert], function(){})
        }
      }
    }
    else if( type == 4 ) // primary header icon
    {
      buttonColor = appManager.getColorForKey("HeaderIconColor");
      buttonTitleColor = appManager.getColorForKey("HeaderColor");
      buttonBorderColor = 'transparent';//appManager.getColorForKey("ButtonPrimaryBorderColor");
      rippleColor = appManager.getColorForKey("HeaderColor", 0.2);
      style.push({width:26,height:26, marginTop:10, marginRight:12, alignSelf:'center'})
    }
    else if( type == 5 ) // search clear
    {
      buttonColor = 'transparent'
      buttonTitleColor = appManager.getColorForKey("GeneralTitleColor", 0.6);
      buttonBorderColor = 'transparent';//appManager.getColorForKey("ButtonPrimaryBorderColor");
      rippleColor = appManager.getColorForKey("HeaderColor", 0.2);
      style.push({width:26,height:26, marginTop:0, marginRight:26, alignSelf:'center'})
      iconSize = 16;
    }
    else if( type == 6 ) // clear bg
    {
      buttonColor = 'transparent'
      buttonTitleColor = appManager.getColorForKey("GeneralTitleColor", 0.6);
      buttonBorderColor = 'transparent';//appManager.getColorForKey("ButtonPrimaryBorderColor");
      rippleColor = appManager.getColorForKey("HeaderColor", 0.2);
      style.push({width:26,height:26, marginTop:0, alignSelf:'center'})
      iconSize = 16;
    }
    else if( type == 7 ) // tutorial icon
    {
      buttonColor = 'transparent';//appManager.getColorForKey("ButtonSecondaryColor");
      buttonTitleColor = appManager.getColorForKey("InstructionTitleColor");
      buttonBorderColor = 'transparent';//appManager.getColorForKey("ButtonSecondaryBorderColor");
      iconSize = 30;
    }
    else if( type == 8 ) // tutorial icon
    {
      buttonColor = 'transparent';//appManager.getColorForKey("ButtonSecondaryColor");
      buttonTitleColor = appManager.getColorForKey("HeaderColor");
      buttonBorderColor = 'transparent';//appManager.getColorForKey("ButtonSecondaryBorderColor");
      iconSize = 60;
      style.push({width:60,height:60, marginTop:0, alignSelf:'center'})
    }

    lineHeight = iconSize;

    var moreProps = {accessibilityLabel: accessibilityLabel, enabled:enabled};
    if( rippleColor != null ) moreProps.rippleColor = rippleColor;
    if( typeof buttonColor !== 'undefined' ) style.push({backgroundColor:buttonColor});
    if( this.props.buttonColorOverride != null ) style.push({backgroundColor:this.props.buttonColorOverride});
    if( this.props.iconSizeOverride != null )
    {
      iconSize = this.props.iconSizeOverride;
    }

    if( ionicIconName != null && ionicIconName.length ) style.push({paddingTop:4});

    style.push({opacity:this.state.opacity});

    if( typeof onPress === 'undefined' || onPress == null ) onPress = ()=>{};

    return (
      <AccentColoredFab
        key="button"
        onPress={() => {onPress()}}
        shadowColor={buttonBorderColor}
        shadowRadius={2}
        shadowOffset={{width:0, height:2}}
        shadowOpacity={0.4}
        backgroundColor={buttonColor}
        testID={iconName}
        style={style} {...moreProps}>
        {
          ionicIconName != null && ionicIconName.length > 0 ?
            <Ionicon name={ionicIconName} size={ionIconSize} color={buttonTitleColor} style={[styles.iconStyle,addedIconStyle]} {...other}/>
          :
            <Icon name={iconName} size={iconSize} color={buttonTitleColor} style={[styles.iconStyle,{lineHeight:lineHeight,height:iconSize},addedIconStyle]} {...other}/>
        }
      </AccentColoredFab>
    )
  }
});

var styles = StyleSheet.create({
buttonStyle:
{
  flexDirection:'row',
  width:44,
  height:44,
  borderRadius:22,
  alignItems:'center',
  justifyContent:'center',
  alignSelf:'center',
  backgroundColor:'transparent',
  textAlign:'center',
},
iconStyle:
{
  alignItems:'center',
  justifyContent:'center',
}
})


module.exports = ReUpIconButton;



// WEBPACK FOOTER //
// ./src/ReUpIconButton.js